import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 查询抽奖活动列表
  getlotterys: option => {
    return request3('v1/lottery/getlotterys', option, true)
  },
  // 查询抽奖活动
  getlottery: option => {
    const urls = urlStringify(option)
    return request3('v1/lottery/getlottery' + urls, {}, true)
  },
  // 新增抽奖活动
  addlottery: option => {
    return request3('v1/lottery/addlottery', option, true)
  },
  // 修改抽奖活动
  updatelottery: option => {
    return request3('v1/lottery/updatelottery', option, true)
  },
  // 删除抽奖活动
  deletelottery: option => {
    const urls = urlStringify(option)
    return request3('v1/lottery/deletelottery' + urls, {}, true)
  },
  // 发布抽奖活动
  publishlottery: option => {
    return request3('v1/lottery/publishlottery', option, true)
  },
  // 结束抽奖活动
  closelottery: option => {
    const urls = urlStringify(option)
    return request3('v1/lottery/closelottery' + urls, {}, true)
  },
  // 查询中奖记录列表
  getwinningrecords: option => {
    return request3('v1/lottery/getwinningrecords', option, true)
  }
}
